import React from 'react';
import Newsletter from '../components/Newsletter';
import FeaturedEvent from '../components/FeaturedEvent';
import EventCard from '../components/EventCard';
import { events } from '../mock';

const Events = () => {
  const featured = events.find((e) => e.featured);
  const others = events.filter((e) => !e.featured);

  return (
    <div>
      {/* Hero */}
      <section className="relative overflow-hidden bg-[#0c1119] pt-36 pb-16 border-b border-white/10">
        <img src="/events/diaspora-voices.png" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0e16] via-[#0a0e16]/70 to-[#0a0e16]/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e16] via-transparent to-transparent" />
        <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10 max-w-3xl">
          <span className="dctv-eyebrow text-[#e8743b]">Events</span>
          <h1 className="mt-4 font-serif-dctv text-5xl sm:text-6xl font-bold text-white">Where the community comes together</h1>
          <p className="mt-5 text-lg leading-relaxed text-[#e7e9ee]/75">
            Celebrations, commemorations and gatherings - from community celebrations in The Hague to diaspora festivals and global trade fairs. We shine a light on the people and organisations bringing our communities together.
          </p>
        </div>
      </section>

      {/* Featured event */}
      <section className="bg-[#0a0e16] py-16 border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10"><FeaturedEvent event={featured} /></div>
      </section>

      {/* Other events */}
      <section className="bg-[#0a0e16] py-16">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <span className="dctv-eyebrow text-[#e8743b]">More on the calendar</span>
          <h2 className="mt-3 font-serif-dctv text-3xl sm:text-4xl font-bold text-white">Local &amp; international events</h2>
          <div className="grid md:grid-cols-2 gap-8 mt-10">
            {others.map((ev) => <EventCard key={ev.id} event={ev} />)}
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Events;
